import { SET_TEMPORARY_UPLOAD_RUNS } from './constants';

const initialState = {
    temporaryUploadRuns: [],
};

export default function distributionTrackingReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case SET_TEMPORARY_UPLOAD_RUNS: {
            return {
                ...state,
                temporaryUploadRuns: action.temporaryUploadRuns,
            };
        }
        default:
            return state;
    }
}
